import { Pipe, PipeTransform } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";
import { IObservationDefinition, IOComponent } from "@comunicare/comunicare-interfaces";
import { SessionService } from "../../../providers/session.service";

const OBSERVATION_LOINC_MAP_CONVERTOR = {
  1: "8310-5", // temperature
  2: "55284-4", // blood pressure
  3: "8867-4", // heart rate
  4: "3141-9", // body weight
};

@Pipe({ name: "translateComponent" })
export class TranslateComponentPipe implements PipeTransform {
  constructor(private sessionService: SessionService) {}
  transform(component: IOComponent, allDefinitions: IObservationDefinition[]): string {
    const def = allDefinitions.find((d) => d.loinc === component.parentObservation?.code.coding[0].code);
    if (!def) {
      return component.code.coding[0].code;
    }
    const cDef = this.getComponent(component.code.coding[0].code, def);
    if (!cDef) {
      return component.code.coding[0].code;
    } // not exists

    if (cDef.shortnameTranslation) {
      return Tools.getTranslation(cDef.shortnameTranslation, this.sessionService.userLang, cDef.loinc);
    }

    return Tools.getTranslation(cDef.nameTranslation, this.sessionService.userLang, cDef.loinc);
  }
  private getComponent(loinc: string | number, obsDef: IObservationDefinition) {
    const loincStr: string = OBSERVATION_LOINC_MAP_CONVERTOR[loinc] || loinc;
    for (const compo of obsDef.components) {
      if (compo.loinc === loincStr) {
        return compo;
      }
    }
    return null;
  }
}
